import { tariffPlanKeys } from 'utils/const/plans';
import { chain } from 'lodash';
import { AccountType } from 'utils/api/models/accounts/accountType';
import { TARIFF_PACKAGE_NAMA } from 'views/Numbers/constants';

const WFBB_TARIFF_PLAN = 'TARIFF_WFBB';

export const tariffPlan = (products: any, key: string, accountType: AccountType) => {
	if (products) {
		let keys: string[] = tariffPlanKeys[accountType];
		if (accountType === AccountType.WFBB) {
			return chain(products)
				.filter((element) => String(element[key]).indexOf(WFBB_TARIFF_PLAN) >= 0)
				.head()
				.value();
		}
		const currentProduct = chain(products)
			.filter((element) => keys?.indexOf(element[key]) >= 0)
			.map((element) => ({
				...element,
				priority: keys?.indexOf(element[key]),
			}))
			.orderBy(['priority', 'startDate'], ['asc', 'desc'])
			.head()
			.value();
		if (currentProduct && currentProduct.group && currentProduct.group === TARIFF_PACKAGE_NAMA) {
			const customizedProduct = chain(products)
				.filter((element) => keys?.indexOf(element[key]) >= 0)
				.map((element) => ({
					...element,
					priority: keys?.indexOf(element[key]),
				}))
				.orderBy(['priority', 'startDate'], ['asc', 'desc']).nth(1).value()
			if (customizedProduct && currentProduct.startDate === customizedProduct.startDate && customizedProduct?.name?.length > currentProduct?.name?.length) {
				return customizedProduct
			}
		}
		return currentProduct


	}
	return undefined;
};
